import { Controller } from "@hotwired/stimulus"
import { warning } from "../pure/notifications"
import { numberWithCommas } from "../pure/utils"

// Connects to data-controller="document-item-form"
export default class extends Controller {
  static outlets = [ "document-form" ]
  static values = {
    index: Number,
    productId: Number,
    productBatchId: Number,
    total: Number,
    productGoesOut: Boolean,
    pricesAreCost: Boolean
  }
  static targets = [
    "productBatchId", "productId", "productCode", "productName",
    "quantity", "unitPrice", "discount", "totalPrice", "unitName",
    "dueDate"
  ]

  connect() {
    this.product = {}
  }

  quantityTargetConnected(element) {
    element.addEventListener("focus", () => element.select())
  }

  searchProduct() {
    this.documentFormOutlet.searchProduct(this)
  }

  async findProductByCode(event) {
    const productCode = event.target.value
    if (!productCode) {
      this.setProduct()
      return
    }

    const allowsForPurchase = this.documentFormOutlet.allowsForPurchaseValue
    const query = allowsForPurchase ? "?allows_for_purchase=true" : ""
    try {
      const response = await fetch(`/products/find_by/code/${encodeURIComponent(productCode)}${query}`, {
        headers: { Accept: "application/json" }
      })
      if (!response.ok) throw new Error("not found")
      const product = await response.json()
      this.setProduct(product)
    } catch {
      warning("No encontramos el producto con el código proporcionado.")
      this.setProduct()
      this.productCodeTarget.focus()
    }
  }

  setProduct(product = {}) {
    this.product = product
    this.productIdTarget.value = product.id || ""
    this.productBatchIdTarget.value = ""
    if (this.hasProductNameTarget) this.productNameTarget.innerText = product.name || ""
    this.productCodeTarget.value = product.code || ""

    if (this.hasUnitNameTarget) this.unitNameTarget.innerText = product.unit || ""
    this.quantityTarget.value = "1"
    if (this.hasDiscountTarget) this.discountTarget.value = "0"

    if (this.hasDueDateTarget) {
      this.dueDateTarget.value = ""
      if (product.has_due_date) {
        this.dueDateTarget.classList.remove("hidden")
        this.dueDateTarget.disabled = false
        this.dueDateTarget.required = true
      } else {
        this.dueDateTarget.classList.add("hidden")
        this.dueDateTarget.disabled = true
        this.dueDateTarget.required = false
      }
    }

    if (this.hasUnitPriceTarget) {
      const price = this.pricesAreCostValue ? (product.last_cost || 0) : (product.price || 0)
      if (this.unitPriceTarget instanceof HTMLInputElement) {
        this.unitPriceTarget.value = price
        this.unitPriceTarget.dispatchEvent(new Event("change"))
      } else {
        this.unitPriceTarget.innerText = `${numberWithCommas(Math.round(price))}Gs`
      }
    }

    this.calculateTotalPrice()
    this.addRowIfNeeded()

    if (product.id && product.has_due_date && this.productGoesOutValue) {
      this.documentFormOutlet.searchBatch(this, product.id)
    }
  }

  setProductBatch(batchId, dueDate) {
    this.productBatchIdTarget.value = batchId || ""
    if (this.hasDueDateTarget) this.dueDateTarget.value = dueDate || ""
  }

  calculateTotalPrice() {
    const quantity = parseFloat(String(this.quantityTarget.value).replace(/\./g, "").replace(/,/g, ".")) || 0
    const discount = this.hasDiscountTarget
      ? parseFloat(String(this.discountTarget.value).replace(/\./g, "").replace(/,/g, ".")) || 0
      : 0

    let unitPrice = 0
    if (this.hasUnitPriceTarget) {
      const raw = this.unitPriceTarget instanceof HTMLInputElement
        ? String(this.unitPriceTarget.value).replace(/\./g, "").replace(/,/g, ".")
        : String((this.pricesAreCostValue ? this.product?.last_cost : this.product?.price) || 0)
      unitPrice = parseFloat(raw) || 0
    }

    const totalPrice = (quantity * unitPrice) - discount
    this.totalValue = totalPrice

    if (this.hasTotalPriceTarget) {
      this.totalPriceTarget.innerText = `${numberWithCommas(Math.round(totalPrice))}Gs`
    }
    this.totalValueChanged()
  }

  totalValueChanged() {
    if (this.hasDocumentFormOutlet) this.documentFormOutlet.calculateTotal()
  }

  documentFormOutletConnected() {
    this.documentFormOutlet.calculateTotal()
  }

  addRowIfNeeded() {
    const items = document.querySelectorAll(".detail-product-code-id:placeholder-shown")
    if (items.length === 0) {
      const addBtn = document.getElementById("document_item_add_btn")
      if (addBtn) addBtn.click()
    }
  }
}
